import React, { Component } from 'react'
import { ThemeProvider } from 'styled-components'
import { themes as kawaUIThemes } from '@kawaui/theme'
import { DEFAULT_THEME_NAME, KAWAUI_THEME_MAP } from 'constants/theme'
import withConnect from './connector'

// type Props = {|
//   +children: Node,
//   +themeName: string
// |}

// type State = {|
//   theme: {} | Theme
// |}

export class ThemeProviderHolder extends Component {
  state = {
    theme: {}
  }

  componentDidUpdate (prevProps) {
    const { themeName } = this.props
    const prevThemeName = prevProps.themeName

    if (prevThemeName !== themeName) {
      const kawaUIThemeName = KAWAUI_THEME_MAP[themeName] ?? KAWAUI_THEME_MAP[DEFAULT_THEME_NAME]
      const theme = kawaUIThemes[kawaUIThemeName]

      this.setState({ theme })
    }
  }

  render () {
    const { theme } = this.state
    const { children } = this.props

    return (
      <ThemeProvider theme={theme}>
        {children}
      </ThemeProvider>
    )
  }
}

export default withConnect(ThemeProviderHolder)
